
import React from 'react'
import Box from './Box'
import './JSONViewer.css'

/**
 * JSONViewer component.
 */

export default function JSONViewer({ value, minimal, wrap, ...props }) {
  return <Box is="pre" fontSize={1} className={`JSON ${wrap && 'wrap'}`} {...props}>
    <code>
      {minimal
        ? renderMinimal(value)
        : renderIdentity(value)}
    </code>
  </Box>
}

/**
 * renderMinimal value.
 */

function renderMinimal(value, children = [], depth = 0) {
  if (Array.isArray(value)) {
    children.push('\n')
    value.forEach((v, i) => {
      children.push(indent(depth))
      renderMinimal(v, children, depth + 1)
      if (i < value.length - 1) {
        children.push('\n')
      }
    })
    return children
  }

  if (value == null) {
    children.push(<span className="value null">null</span>)
    return children
  }

  if (typeof value == 'number') {
    children.push(<span className="value number">{value}</span>)
    return children
  }
  
  if (typeof value == 'string') {
    // TODO: escape quotes
    children.push(<span className="value string">{value}</span>)
    return children
  }
  
  if (typeof value == 'boolean') {
    children.push(<span className="value boolean">{'' + value}</span>)
    return children
  }


  if (value instanceof Date) {
    children.push(<span className="value string">{value.toISOString()}</span>)
    return children
  }

  if (depth > 0) children.push('\n')
  const keys = Object.keys(value)
  keys.forEach((k, i) => {
    children.push(indent(depth))
    children.push(<span className="key">{k}</span>)
    renderMinimal(value[k], children, depth + 1)
    if (i < keys.length - 1) {
      children.push('\n')
    }
  })

  return children
}

/**
 * renderIdentity value.
 */

function renderIdentity(value, children = [], depth = 1) {
  if (Array.isArray(value)) {
    children.push('[\n')
    value.forEach((v, i) => {
      children.push(indent(depth))
      renderIdentity(v, children, depth + 1)
      if (i < value.length - 1) {
        children.push(',\n')
      }
    })
    children.push('\n' + indent(depth-1) + ']')
    return children
  }

  if (value == null) {
    children.push(<span className="value null">null</span>)
    return children
  }

  if (typeof value == 'number') {
    children.push(<span className="value number">{value}</span>)
    return children
  }
  
  if (typeof value == 'string') {
    // TODO: escape quotes 
    children.push(<span className="value string">{value}</span>)
    return children
  }
  
  if (typeof value == 'boolean') {
    children.push(<span className="value boolean">{'' + value}</span>)
    return children
  }

  if (value instanceof Date) {
    children.push(<span className="value string">{value.toISOString()}</span>)
    return children
  }

  children.push('{\n')
  const keys = Object.keys(value)
  keys.forEach((k, i) => {
    children.push(indent(depth))
    children.push(<span className="key">{k}</span>)
    renderIdentity(value[k], children, depth + 1) 
    if (i < keys.length - 1) {
      children.push(',')
    }
    children.push('\n')
  })
  children.push(indent(depth-1) + '}')

  return children
}

/**
 * indent helper.
 */

function indent(n) {
  return '  '.repeat(n)
}